export default function createServiceProfile({ next, store }) {
  const status = store.getters['auth/isAuth']
  if (status) {
    return next()
  }
  return next({ name: 'auth-login' })
}
